import './Total.scss';

import cn from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Price from '@/common/components/blocks/Price/Price';

import useTotal from './useTotal';

const Total = ({
  amountLeftForFreeShipping,
  context,
  children,
  className,
  isUpdated,
  label,
  pricesAndStocks,
  products,
  subtotal,
  total,
  type,
}) => {
  const { t } = useTranslation();

  const { hasData, total: totalCalculated } = useTotal({
    isUpdated,
    pricesAndStocks,
    products,
    total,
  });

  return (
    <div className={cn('total', className)} data-qa-id={context || 'total'}>
      <div className="total__price">
        <span className="label">
          {label || t('ebat:entities:common.aside.total')}
        </span>
        <div className="value">
          <Price
            context="total-value"
            type={type}
            value={hasData ? subtotal || totalCalculated : null}
          />
        </div>
        {children ? <div className="additional">{children}</div> : null}
      </div>
      {amountLeftForFreeShipping !== null && (
        <div
          className="total__shipping"
          data-qa-id="aside-total-amount-hipping"
        >
          {hasData ? (
            <>
              {amountLeftForFreeShipping !== 0 && (
                <div className="label">
                  {t('ebat:entities:common.aside.free_shipping_missing')}&nbsp;
                  <Price
                    className="value"
                    context="free-shipping"
                    sup={false}
                    value={hasData ? amountLeftForFreeShipping : null}
                  />
                </div>
              )}
            </>
          ) : (
            <>{null}</>
          )}
        </div>
      )}
    </div>
  );
};

Total.defaultProps = {
  amountLeftForFreeShipping: null,
  children: null,
  context: null,
  className: null,
  isUpdated: false,
  label: null,
  pricesAndStocks: {},
  products: [],
  subtotal: null,
  total: null,
  type: 'HT',
};

Total.propTypes = {
  amountLeftForFreeShipping: PropTypes.number,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  context: PropTypes.string,
  isUpdated: PropTypes.bool,
  label: PropTypes.string,
  pricesAndStocks: PropTypes.shape({
    // for HOC
    get: PropTypes.func,
  }),
  products: PropTypes.arrayOf(
    PropTypes.shape({
      // for HOC
      quantity: PropTypes.number,
      is_selected: PropTypes.bool,
      price_and_stock: PropTypes.shape({
        price: PropTypes.shape({
          customer_price: PropTypes.number,
          public_price: PropTypes.number,
        }),
      }),
    }),
  ),
  subtotal: PropTypes.number,
  total: PropTypes.number,
  type: PropTypes.string,
};

export default Total;
